import React, { useEffect, useState } from 'react';
import { Panel } from 'primereact/panel';
import { Chart } from 'primereact/chart';

export default function ListaEsperaTipoProductoChart({ data = [], title = 'Solicitudes por tipo y metraje', initialCollapsed = true }) {
    const [collapsed, setCollapsed] = useState(initialCollapsed);

    const [chartDataEspera, setChartDataEspera] = useState({ labels: [], datasets: [] });
    const [chartOptionsEspera, setChartOptionsEspera] = useState({});

    useEffect(() => {
        const dataArray = Array.isArray(data) ? data : [];

        const buildChartFor = (statusLabel) => {
            const counts = {};

            const filtered = dataArray.filter((item) => {
                const estado = (item?.estado || '').toString().trim().toUpperCase();
                return estado === statusLabel;
            });

            filtered.forEach((item) => {
                const metraje = Number(item?.metraje_requerido) || 0;
                const tipos = Array.isArray(item?.tipos_producto) && item.tipos_producto.length > 0
                    ? item.tipos_producto.map((tp) => tp?.descripcion || 'Sin tipo')
                    : [item?.tipo_producto?.descripcion || 'Sin tipo'];

                tipos.forEach((tipo) => {
                    const key = `${tipo}__${metraje}`;
                    counts[key] = (counts[key] || 0) + 1;
                });
            });

            const entries = Object.entries(counts).map(([key, count]) => {
                const [tipo, metrajeStr] = key.split('__');
                const metraje = Number(metrajeStr);
                return { tipo, metraje, count };
            }).sort((a, b) => a.tipo.localeCompare(b.tipo) || a.metraje - b.metraje);

            const labels = entries.map((e) => `${e.tipo} ${e.metraje} mts`);
            const values = entries.map((e) => e.count);

            const chartData = {
                labels,
                datasets: [
                    {
                        label: 'Cantidad',
                        data: values,
                        backgroundColor: values.map(() => 'rgba(66, 165, 245, 0.6)'),
                        borderColor: values.map(() => '#42A5F5'),
                        borderWidth: 1,
                        barThickness: 12,
                        maxBarThickness: 16
                    }
                ]
            };

            const chartOptions = {
                indexAxis: 'x',
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: { enabled: true },
                    title: { display: true, text: `${statusLabel}` }
                },
                scales: {
                    x: { beginAtZero: true, ticks: { precision: 0 } },
                    y: { ticks: { autoSkip: false } }
                }
            };

            return { chartData, chartOptions };
        };

        const espera = buildChartFor('ESPERA');


        setChartDataEspera(espera.chartData);
        setChartOptionsEspera(espera.chartOptions);

    }, [data, title]);

    const handlePanelClickCapture = (e) => {
        // Ignora clics sobre el botón de toggle del Panel
        const isToggler = e.target?.closest?.('.p-panel-header-icon') || e.target?.closest?.('.p-panel-toggler');
        if (isToggler) return;
        setCollapsed((prev) => !prev);
    };

    return (
        <div onClickCapture={handlePanelClickCapture}>
            <Panel header={title} toggleable collapsed={collapsed} onToggle={(e) => setCollapsed(e.value)}>
                <Chart type="bar" data={chartDataEspera} options={chartOptionsEspera} style={{ height: '160px' }} />
            </Panel>
        </div>
    );
}